import {
  AspectRatio,
  Avatar,
  Box,
  HStack,
  Image,
  Text,
  VStack
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import FAIcon from "./FAIcon";
import Skeletons from "./Skeletons";

const StreamPreview = ({
  onClick,
  title,
  avatarUrl,
  creatorName,
  mode,
  popularity,
  streamId,
}) => {
  const [loaded, setLoaded] = useState(false);
  const avatarSrc = avatarUrl ;

  useEffect(() => {
    if (avatarSrc) {
      const image = new window.Image();
      image.src = avatarSrc;
      image.onload = () => setLoaded(true);
      image.onerror = () => setLoaded(true); // Still show component even if image fails
    } else {
      setLoaded(true);
    }
  }, [avatarSrc]);

  if (!loaded) return <Skeletons.Video />;

  return (
    <VStack spacing={2} align="stretch" color="white">
      <Box position="relative" role="button" onClick={onClick} cursor="pointer">
        <AspectRatio ratio={1}>
          <Box
            rounded="lg"
            overflow="hidden"
            position="relative"
            bg="gray.800"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {avatarSrc ? (
              <Image
                src={avatarSrc}
                alt={creatorName}
                objectFit="cover"
                width="100%"
                height="100%"
                loading="lazy"
              />
            ) : (
              <Avatar
                name={creatorName}
                size="2xl"
                bg="gray.600"
                color="gray.300"
              />
            )}
            
            {/* Overlay gradient for better text readability */}
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bg="blackAlpha.400"
              borderRadius="lg"
            />
          </Box>
        </AspectRatio>

        {/* Mode label on top right - Only show for private mode */}
        {mode === "private" && (
          <Box
            position="absolute"
            top={2}
            right={2}
            bg="purple.500"
            color="white"
            px={2}
            py={1}
            borderRadius="md"
            fontSize="xs"
            fontWeight="normal"
            textTransform="uppercase"
            boxShadow="0 2px 8px rgba(0,0,0,0.3)"
            zIndex={2}
          >
            私密直播中
          </Box>
        )}

        {/* Popularity count on bottom right */}
        {popularity != null && popularity > 0 && (
          <HStack
            position="absolute"
            bottom={2}
            right={2}
            spacing={1}
            zIndex={2}
          >
            <FAIcon 
              type="fire" 
              color="#F6A01E" 
              fontSize="xs"
            />
            <Text
              color="#F6A01E"
              fontSize="xs"
              fontWeight="bold"
              textShadow="0 1px 3px rgba(0,0,0,0.8)"
            >
              {popularity}
            </Text>
          </HStack>
        )}
      </Box>

      {/* Creator name */}
      <Text
        fontSize="xs"
        color="gray.400"
        fontWeight="normal"
        noOfLines={1}
      >
        {creatorName || "主播"}
      </Text>

      {/* Stream title */}
      <Text
        fontSize="sm"
        fontWeight="medium"
        lineHeight="short"
        noOfLines={2}
        minH="2.5em"
        color="white"
      >
        {title || "直播中"}
      </Text>
    </VStack>
  );
};

export default StreamPreview; 